export default __webpack_public_path__ + "static/4-be80ce30e1be4e18a67da640101d260a.png";